export default __webpack_public_path__ + "801b51642aec19aff05d57074038812d.png";